import { REST_METHOD, REST_URL } from 'constants/index';
import { requestMarketplace } from './api';
import { CartDetailsPayload, MarketplaceUser, SearchProductPayload } from 'models/types/Marketplace';

async function getUser(email: string): Promise<MarketplaceUser> {
  try {
    const requestParams = {
      url: REST_URL.GET_USER,
      method: `${REST_METHOD.GET}`,
      queryParams: { email },
    };

    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function getUserToken(user_id: string) {
  try {
    const requestParams = {
      url: REST_URL.GET_USER_TOKEN,
      method: `${REST_METHOD.POST}`,
      queryParams: { user_id },
    };

    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function getListCatalog(params: { user_id: string; category_id?: string; persona_id?: string }) {
  try {
    const requestParams = {
      url: REST_URL.GET_LIST_CATALOG,
      method: `${REST_METHOD.GET}`,
      queryParams: params,
    };

    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error
  }
}

async function getFilterOptions(params: {
  user_id: string;
  grouping_id: string;
  persona_id?: string;
  locale?: string;
}, data?: any) {
  try {
    const { grouping_id, ...restParams } = params;
    const requestParams = {
      url: `${REST_URL.CATALOG_GROUPING}/${params.grouping_id}${REST_URL.FILTERS}`,
      method: `${REST_METHOD.POST}`,
      data: data || {},
      queryParams: restParams,
    };

    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error
  }
}

async function getProductItems(params: {
  user_id: string;
  grouping_id: string;
}) {
  try {
    const requestParams = {
      url: REST_URL.GET_PRODUCT_ITEMS,
      method: `${REST_METHOD.GET}`,
      queryParams: params,
    };

    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error
  }
}

async function searchProductItems(params: {
  user_id: string;
  page_index?: number;
  page_size?: number;
  sort?: string;
  persona_id?: string;
  locale?: string;
}, data?: SearchProductPayload) {
  try {
    const requestParams = {
      url: REST_URL.SEARCH_PRODUCTS,
      method: `${REST_METHOD.POST}`,
      data,
      queryParams: params,
    };

    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error
  }
}

async function getSortingOptions(params: {user_id: string; locale: string}) {
  try {
    const requestParams = {
      url: REST_URL.CATALOG_METADATA,
      method: `${REST_METHOD.GET}`,
      queryParams: params,
    };

    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error
  }
}

async function getOrderSortingOptions(params: {user_id: string; locale: string}) {
  try {
    const requestParams = {
      url: `/${params.user_id}${REST_URL.ORDERS_METADATA}`,
      method: `${REST_METHOD.GET}`,
      queryParams: params,
    };

    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error
  }
}

async function getProductDetail(id: string, user_id: string, locale: string) {
  const requestParams = {
    url: REST_URL.PRODUCT_DETAIL_MARKETPLACE,
    method: REST_METHOD.GET,
    queryParams: { sku: id, user_id, locale }
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
}

async function getCartDetails(userId: string, locale: string) {
  const requestParams = {
    url: REST_URL.GET_CART_DETAILS,
    method: REST_METHOD.GET,
    queryParams: { user_id: userId, locale }
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

async function updateCartDetails<T = CartDetailsPayload>(
  payload: T & { userId: string },
) {
  const requestParams = {
    url: REST_URL.UPDATE_CART_DETAILS,
    method: REST_METHOD.PUT,
    data: payload,
    queryParams: { user_id: payload.userId },
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
}


async function submitOrderRequest(payload: {
  addressId: string;
  items: {
    sku: string;
    quantity: number;
    approval?: { type: string };
  }[];
  disclaimer: boolean;
  userId: string;
  approval?: {
    type: string;
    assigned_approver: string | undefined;
  }
}) {
  const requestParams = {
    url: REST_URL.SUBMIT_ORDER,
    method: REST_METHOD.POST,
    data: payload,
    queryParams: { user_id: payload.userId },
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
}
async function getShippingAddressOfUser(user_id: string) {
    const requestParams = {
      url: REST_URL.GET_SHIPPING_ADDRESS,
      method: `${REST_METHOD.GET}`,
      queryParams: {user_id}
    };
    const response = await requestMarketplace(requestParams);
    return response.data;
};
async function createShippingAddress(user_id: string, data: any) {
    const requestParams = {
      url: REST_URL.CREATE_SHIPPING_ADDRESS,
      method: `${REST_METHOD.POST}`,
      queryParams: {user_id},
      data: data
    };
    const response = await requestMarketplace(requestParams);
    return response;
};
async function updateShippingAddress(user_id: string, address_id: string , data: any) {
    const requestParams = {
      url: REST_URL.UPDATE_SHIPPING_ADDRESS,
      method: `${REST_METHOD.PUT}`,
      queryParams: {user_id, address_id},
      data: data
    };
    const response = await requestMarketplace(requestParams);
    return response;
};
async function deleteShippingAddress(user_id: string, _id: string) {
    const requestParams = {
      url: REST_URL.DELETE_SHIPPING_ADDRESS,
      method: `${REST_METHOD.DELETE}`,
      queryParams: {user_id: user_id, address_id: _id},
    };
    const response = await requestMarketplace(requestParams);
    return response.data;
};

async function getOrderListByUser(params: {
  user_id: string;
  page_index: number;
  page_size: number;
  locale: string;
}) {
  try {
    const requestParams = {
      url: REST_URL.GET_ORDER_LIST,
      method: `${REST_METHOD.GET}`,
      queryParams: params,
    };

    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error
  }
}

async function getOrderDetail(params: { user_id: string; order_id: string, locale: string }) {
  try {
    const requestParams = {
      url: REST_URL.GET_ORDER,
      method: REST_METHOD.GET,
      queryParams: params,
    };
    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function markOrderItemReceived(params: { user_id: string; item_id: string }) {
  try {
    const requestParams = {
      url: REST_URL.MARK_ORDER_ITEM_RECEIVED,
      method: REST_METHOD.PUT,
      queryParams: params,
    };
    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function cancelOrder({ userId, orderId }: { userId: string; orderId: string }) {
  const requestParams = {
    url: REST_URL.CANCEL_ORDER,
    method: REST_METHOD.PUT,
    queryParams: {
      user_id: userId,
      order_id: orderId
    }
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

async function cancelOrderItem({ userId, itemId }: { userId: string; itemId: string }) {
  const requestParams = {
    url: `${REST_URL.ORDER}/users/${userId}/items/${itemId}/cancel`,
    method: REST_METHOD.PUT,
    queryParams: { user_id: userId },
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

async function clearCart(userId: string) {
  const requestParams = {
    url: REST_URL.CLEAR_CART,
    method: REST_METHOD.DELETE,
    queryParams: { user_id: userId },
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

async function getPendingApprovals(userId: string) {
  const requestParams = {
    url: REST_URL.GET_PENDING_APPROVALS,
    method: REST_METHOD.GET,
    queryParams: { user_id: userId },
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

async function getCompleteApprovals(manager_id: string, userId?: string ) {
  const requestParams = {
    url: `${REST_URL.ORDER}${REST_URL.USERS}/${manager_id}/${REST_URL.PRIOR_APPROVALS_BY_MANAGER}`,
    method: REST_METHOD.GET,
    queryParams: { user_id: userId },
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

async function submitOrderApproval(userId: string, 
  orderId: string, 
  approvalStatus: string, 
  approvalBy: string,
  comment: any,
) {
  const requestParams = {
    url: REST_URL.SUBMIT_ORDER_APPROVALS,
    method: REST_METHOD.POST,
    queryParams: {
      user_id: userId,
      order_id: orderId
    },
    data: {
      approval: {
        approval_status: approvalStatus,
        approved_by: approvalBy,
        approval_reason: comment
      }
    }   
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};


async function checkCategoryApprovalPolicy(payload: {
  userLevel?: number;
  userDevices?: number;
  deviceCost?: number;
  deviceBrand?: string;
  userLocation?: string;
  deviceModel?: string;
  userId: string;
}) {
  const optionalParam = <T = string>(
    key: keyof typeof payload,
    value: T | undefined,
  ) => {
    const params = { [key]: value };
    if (typeof value === 'number' && value === 0) {
      return params;
    }

    if (value) {
      return params;
    }

    return {};
  };

  const data = {
      ...optionalParam<number>('userLevel', payload.userLevel),
      ...optionalParam<number>('userDevices', payload.userDevices),
      ...optionalParam<number>('userDevices', payload.userDevices),
      ...optionalParam('deviceBrand', payload.deviceBrand),
      ...optionalParam('userLocation', payload.userLocation),
      ...optionalParam('deviceModel', payload.deviceModel),
  };

  const requestParams = {
    url: REST_URL.CATEGORY_APPROVAL_POLICY,
    method: REST_METHOD.POST,
    data,
    queryParams: { user_id: payload.userId },
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

async function getSupportedCountries(user_id: string) {
  const requestParams = {
    url: REST_URL.PARTNER_COUNTRIES_LIST,
    method: REST_METHOD.GET,
    queryParams: { user_id },
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

async function getAddressConfig(params: { user_id: string }) {
  const requestParams = {
    url: REST_URL.GET_ADDRESS_CONFIG,
    method: REST_METHOD.GET,
    queryParams: params,
    
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

async function updateUserCountry(params: { user_id: string }, payload: { country?: string, equipment_submitted?: boolean }) {
  const requestParams = {
    url: REST_URL.WIDGET_STYLE_PROFILE,
    method: REST_METHOD.POST,
    queryParams: params,
    data: payload,
    
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

async function getListFilterMyOrders(userId: string, locale: string) {
  try {
    const requestParams = {
      url: `/${userId}` + REST_URL.GET_FILTER_MY_ORDERS,
      method: REST_METHOD.GET,
      queryParams: {
        user_id: userId,
        locale: locale,
      }
    };
    const response = await requestMarketplace(requestParams);
    return response.data;
  } catch(error) {
    throw error;
  }
};

async function getFilterOptionWithoutGroupingId(params: {user_id: string, locale: string}, data: SearchProductPayload) {
  const requestParams = {
    url: `${REST_URL.CATALOG_GROUPING}${REST_URL.FILTERS}`,
    method: `${REST_METHOD.POST}`,
    queryParams: params,
    data: data
  };
  const response = await requestMarketplace(requestParams);
  return response.data;
};

const MarketplaceServices = {
  getUser,
  getUserToken,
  getListCatalog,
  getFilterOptions,
  getProductItems,
  getProductDetail,
  getShippingAddressOfUser,
  createShippingAddress,
  getCartDetails,
  updateCartDetails,
  submitOrderRequest,
  getOrderListByUser,
  getOrderDetail,
  markOrderItemReceived,
  deleteShippingAddress,
  clearCart,
  searchProductItems,
  updateShippingAddress,
  getSortingOptions,
  getOrderSortingOptions,
  cancelOrder,
  cancelOrderItem,
  getPendingApprovals,
  submitOrderApproval,
  checkCategoryApprovalPolicy,
  getSupportedCountries,
  getAddressConfig,
  updateUserCountry,
  getListFilterMyOrders,
  getCompleteApprovals,
  getFilterOptionWithoutGroupingId
};

export default MarketplaceServices;
